module.exports = __webpack_public_path__ + "static/8de4f497.syncordermodal.jpg";